import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class AdminService {
  public baseUrl = environment.apiUrl;

  constructor(
    private httpClient: HttpClient,
    private storageService: StorageService
  ) { }

  private getHeaders(): HttpHeaders {
    const sessionData = this.storageService.loadSessionData();
    const token = sessionData?.token || '';
    return new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });
  }

  getReports(): Observable<any> {
    return this.httpClient.get(this.baseUrl + '/report/admin', { headers: this.getHeaders() });
  }

  actionReport(reportId: string, action: 'flag' | 'dismiss'): Observable<any> {
    return this.httpClient.post(this.baseUrl + '/report/admin/' + reportId + '/action', { action }, { headers: this.getHeaders() });
  }

  getAppeals(): Observable<any> {
    return this.httpClient.get(this.baseUrl + '/appeal/admin', { headers: this.getHeaders() });
  }

  actionAppeal(appealId: string, action: 'release' | 'block'): Observable<any> {
    return this.httpClient.post(this.baseUrl + '/appeal/admin/' + appealId + '/action', { action }, { headers: this.getHeaders() });
  }
}
